import React from 'react'
import ProjectTile from './project-tile'
import ProjectData from '../api/project-data'

class ProjectLoop extends React.Component {
    render(){
        const projects = []
        const title = this.props.title;
        var max = 36;
        if(this.props.max != undefined){
            max = this.props.max;
        } 
        
        // for(var i=0; i < 3; i++) {
            ProjectData.projects.slice(0, max).map(function(project, i){
                    projects.push(<ProjectTile 
                        project={project}
                        key={i}
                    />)
            });
        // }

        return(
            <section className="projects-loop">
                <div className="gc" gridsize="featured">
                    {title != undefined ? 
                        <div className="span-all">
                            <h3>{title.toUpperCase()}</h3>
                        </div>
                    :null}
                    {projects}
                </div>
            </section>
        )
    }
}

export default ProjectLoop